// extracted by mini-css-extract-plugin
export default {"footerContacts":"FooterContacts_footerContacts__+Tg5M"};